import React from 'react';
import { EventsTable } from 'src/domains/sportsbook/webview/components/eventsTable/EventsTable';
import { FilterKindType } from 'src/domains/sportsbook/webview/components/eventsFilters/EventsFilterType';
import { observer } from 'src/utils/mobx-react';
import { EventsTableHeaderStyle } from 'src/domains/sportsbook/webview/components/eventsTable/EventsMainSectionWrapper';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { EventsCollectionState } from 'src/domains/sportsbook/state/eventsCollection/EventsCollectionState';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';

const filters: Array<FilterKindType> = ['sport'];

interface PropsType {
    showPriceLegend: boolean;
    isLoading: boolean;
}

export const EventsUpcoming = observer('EventsUpcoming', (props: PropsType) => {
    const common = useCommon();
    const config = ConfigComponents.get(common).config;
    const isLoading = props.isLoading;
    const tableLabel = LanguagesState.get(common).getTranslation('special-box.header.upcoming', 'Upcoming');
    const eventsCollection = EventsCollectionState.get(common).listInPlayOrFilteredUpcoming();

    return (
        <EventsTable
            headerStyle={EventsTableHeaderStyle.SOLID}
            filterVersion={config.filtersVersion.eventsUpcoming}
            icon='in-play'
            className='events-table--in-play events-table--dark'
            title={tableLabel}
            showHeaderSport={true}
            allGroupsOpen={true}
            eventsCollection={eventsCollection}
            filters={filters}
            isTogglable={true}
            showPriceLegend={props.showPriceLegend}
            hideNoEventsMessage={true}
            isLoading={isLoading}
            isAmericanFootball={false}
        />
    );
});
